import {
  ComponentRef,
  createComponent,
  Directive,
  effect,
  ElementRef,
  EnvironmentInjector,
  inject,
  input,
  OnDestroy,
  Renderer2
} from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Directive({
  selector: '[libLoadingOverlay]',
  host: {class: 'loading-overlay-container'}
})
export class LoadingOverlayDirective implements OnDestroy {
  public readonly loading = input(false, {alias: 'libLoadingOverlay', transform: coerceBooleanProperty});
  public readonly spinnerDiameter = input(60);
  public readonly spinnerColor = input('primary');
  public readonly customBackdropColor = input('');
  private readonly elementRef = inject(ElementRef);
  private spinnerRef: ComponentRef<MatProgressSpinner> | null = null;
  private overlayEl: HTMLElement | null = null;
  private readonly environmentInjector = inject(EnvironmentInjector);
  private readonly renderer = inject(Renderer2);

  constructor() {
    effect(() => {
      if (this.loading()) {
        this.showOverlay();
      } else {
        this.hideOverlay();
      }
    });
  }

  public ngOnDestroy(): void {
    this.hideOverlay();
  }

  private showOverlay(): void {
    if (!this.overlayEl) {
      this.overlayEl = this.renderer.createElement('div');
      this.renderer.setStyle(this.elementRef.nativeElement, 'position', 'relative');
      this.renderer.setStyle(this.overlayEl, 'position', 'absolute');
      this.renderer.setStyle(this.overlayEl, 'inset', '0');
      this.renderer.setStyle(this.overlayEl, 'z-index', '1000');
      this.renderer.setStyle(this.overlayEl, 'display', 'flex');
      this.renderer.setStyle(this.overlayEl, 'align-items', 'center');
      this.renderer.setStyle(this.overlayEl, 'justify-content', 'center');
      this.spinnerRef = createComponent(MatProgressSpinner, {
        environmentInjector: this.environmentInjector
      });
      this.spinnerRef.instance.diameter = this.spinnerDiameter();
      this.spinnerRef.instance.color = this.spinnerColor();
      this.spinnerRef.instance.mode = 'indeterminate';
      this.spinnerRef.changeDetectorRef.detectChanges();
      if (this.customBackdropColor()) {
        this.renderer.setStyle(this.overlayEl, 'background-color', this.customBackdropColor());
      }
      this.renderer.appendChild(this.elementRef.nativeElement, this.overlayEl);
      this.renderer.appendChild(this.overlayEl, this.spinnerRef.location.nativeElement);
    }
  }

  private hideOverlay(): void {
    this.spinnerRef?.destroy();
    this.spinnerRef = null;
    this.overlayEl?.remove();
    this.overlayEl = null;
  }
}
